<template>
  <aside class="bg-primary-750 text-gray-25 absolute inset-0 z-50 flex w-250 flex-col">
    <div class="bg-primary-850 relative flex h-50 min-h-50 items-center justify-center">
      <router-link to="/">
        <img src="/logo.png" alt="SAS Website Admin Logo" class="h-37 w-37" />
      </router-link>
      <div
        class="absolute right-0 flex h-50 w-50 items-center justify-center md:hidden"
        @click="sidebarVisible = false"
      >
        <i class="bi-x text-35" />
      </div>
    </div>
    <nav class="*:nav-link flex flex-col gap-10 overflow-y-auto p-20">
      <router-link to="/schools">
        <i class="text-20 bi-buildings" />
        <span>Schools</span>
      </router-link>
      <router-link to="/documents">
        <i class="text-20 bi-folder2-open" />
        <span>Documents</span>
      </router-link>
      <router-link to="/forms">
        <i class="text-20 bi-inbox" />
        <span>Forms</span>
      </router-link>
      <router-link to="/reports/enrollment">
        <i class="text-20 bi-file-earmark-bar-graph" />
        <span>Reports</span>
      </router-link>
      <router-link to="/db/editor">
        <i class="text-20 bi-database" />
        <span>Database</span>
      </router-link>
      <router-link v-if="dev" to="/dev">
        <i class="text-20 bi-wrench" />
        <span>Developer</span>
      </router-link>
    </nav>
  </aside>
</template>

<script setup lang="ts">
import { inject, type Ref } from 'vue';
const sidebarVisible = inject<Ref<boolean>>('sidebarVisible')!;
const dev = import.meta.env.DEV;
</script>
